import { useState } from 'react';
import { signInWithMicrosoft } from '../auth/signIn.js';
import { VersionTag } from '../components/VersionTag.js';

export function LoginScreen() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSignIn() {
    setError(null);
    setBusy(true);
    try {
      await signInWithMicrosoft();
    } catch (e) {
      const code = (e as { code?: string })?.code;
      if (code === 'auth/popup-closed-by-user' || code === 'auth/cancelled-popup-request') {
        setError(null);
      } else {
        setError(
          "La connexion Microsoft a échoué. Vérifiez votre compte Altyor ou contactez l'administrateur.",
        );
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <aside className="login__hero" aria-hidden="true">
        <div className="login__brand">Altyor</div>

        <div className="login__mark">
          <img src="/assets/mark-z-coral.svg" alt="" />
        </div>

        <div className="login__hero-copy">
          <div className="login__hero-eyebrow">Facturation électronique B2B</div>
          <h1 className="login__hero-title">
            La plateforme
            <br />
            de réception
            <br />
            des factures <span className="accent">B2B</span>.
          </h1>
          <div className="login__process-pill">
            INNOVER · CONCEVOIR · INDUSTRIALISER · PRODUIRE · REMANUFACTURER
          </div>
        </div>
      </aside>

      <main className="login__form">
        <div className="login__form-eyebrow">Console de facturation</div>
        <h1 className="login__form-title">Bonjour.</h1>
        <p className="login__form-lede">Connectez-vous avec votre compte Microsoft 365 Altyor.</p>

        <button
          type="button"
          className="login__btn"
          onClick={handleSignIn}
          disabled={busy}
          data-testid="login-microsoft"
        >
          <svg width="18" height="18" viewBox="0 0 21 21" aria-hidden="true">
            <rect x="1" y="1" width="9" height="9" fill="#F25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
            <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
          </svg>
          <span>{busy ? 'Connexion…' : 'Se connecter avec Microsoft 365'}</span>
          <span className={`arrow${busy ? '' : ' active'}`}>→</span>
        </button>

        {error ? (
          <div className="login__error" role="alert">
            {error}
          </div>
        ) : null}

        <div className="login__divider">
          Pas d&apos;accès ?
          <br />
          <span style={{ color: 'var(--ink)' }}>Contactez votre administrateur société</span> pour
          être invité.
        </div>

        <div className="login__version">
          <VersionTag />
        </div>
      </main>
    </div>
  );
}
